@if (itemDisplay(); as display) {
  <!-- Scrim: click to dismiss the overlay back to the list. -->
  <button
    type="button"
    class="scrim"
    aria-label="Close overlay"
    [dataSelector]="'cxp-crl-overlay-scrim'"
    (click)="onClose()"
  ></button>

  <section class="overlay" role="dialog" aria-modal="true" [dataSelector]="dataSelector">
    <cxp-crl-overlay-nav
      [requestName]="display.requestName"
      [displayNumber]="display.displayNumber"
      [itemTitle]="item()?.name ?? null"
      [hasPrev]="display.prevItem !== null"
      [hasNext]="display.nextItem !== null"
      (prev)="onNavigateToItem(display.prevItem)"
      (next)="onNavigateToItem(display.nextItem)"
      (closed)="onClose()"
    />

    @if (item(); as item) {
      <div class="overlay-body">
        <div class="overlay-main">
          <cxp-crl-overlay-title
            [sectionName]="display.sectionName"
            [displayNumber]="display.displayNumber"
            [itemTitle]="item.name"
          />

          @if (display.description) {
            <app-text-toggle
              class="overlay-description"
              [text]="display.description"
              [maxCharacters]="220"
              [enableHtml]="true"
              textClass="body-300 color-gray-300"
            />
          }

          <!-- Response card: one shared container (Figma) — the content swaps
               between the text answer and the dropzone; the action row is its footer.
               A content-masked item hides every input and shows only the
               restricted notice, regardless of the item's status. -->
          @if (display.isAuditView) {
            <p class="response-restricted body-300 color-gray-300" [dataSelector]="'cxp-crl-overlay-restricted-response'">
              This response is restricted and cannot be viewed or modified.
            </p>
          } @else {
            <div class="response-card">
              @if (display.isQuestionnaire) {
                <cxp-crl-panel-questionnaire
                  [item]="item"
                  [canEdit]="display.canMarkFinished"
                  [isSubmitting]="isSubmitting()"
                  (answerSaved)="onAnswerSaved($event)"
                  (answerTyped)="onAnswerTyped($event)"
                />
              } @else {
                <cxp-crl-panel-file-upload
                  [item]="item"
                  [requestId]="display.requestId"
                  [canUpload]="display.canUploadFiles"
                  [isSubmitting]="isSubmitting()"
                  [replaceTrigger$]="replaceTrigger$"
                />
              }

              <cxp-crl-panel-item-actions
                [canMarkFinished]="display.canMarkFinished"
                [isMarkedFinished]="display.isMarkedFinished"
                [canUndoFinished]="display.canUndoFinished"
                [canMarkNotApplicable]="display.canMarkNotApplicable"
                [isMissingResponse]="isMissingResponse()"
                [pendingAction]="pendingAction()"
                [isUploadingResponse]="isUploadingResponse()"
                [canUndoNotApplicable]="display.canUndoNotApplicable"
                [isNotApplicable]="item.isNotApplicable"
                [isUndoPending]="display.isUndoPending"
                (markFinished)="onMarkFinished()"
                (undoFinished)="onUndoFinished()"
                (markNotApplicable)="onMarkNotApplicable($event)"
                (undoNotApplicable)="onUndoNotApplicable()"
              />
            </div>
          }

          <mat-tab-group
            mat-align-tabs="start"
            [disableRipple]="true"
            [mat-stretch-tabs]="false"
            class="overlay-tabs"
            [selectedIndex]="selectedTabIndex()"
            [dataSelector]="'cxp-crl-overlay-tabs'"
            (selectedIndexChange)="onTabIndexChange($event)"
          >
            <mat-tab label="Documents" [dataSelector]="'cxp-crl-overlay-tab-documents'">
              <div class="overlay-tab-body">
                <cxp-crl-documents-tab
                  [item]="item"
                  [stagingRows]="stagingRows()"
                  [canEdit]="display.canMarkFinished"
                  (previewRequested)="onPreviewFile($event)"
                  (downloadRequested)="onDownloadFile($event)"
                  (replaceFileRequested)="onReplaceFile($event)"
                  (removeFileRequested)="onRemoveFile($event)"
                  (cancelUploadRequested)="onCancelUpload($event)"
                />
              </div>
            </mat-tab>

            @if (canViewComments()) {
              <mat-tab label="Comments" [dataSelector]="'cxp-crl-overlay-tab-comments'">
                <div class="overlay-tab-body">
                  <cxp-crl-panel-comments [itemId]="item.id" [isAuditView]="isAuditView()" />
                </div>
              </mat-tab>
            }

            <mat-tab label="Activity" [dataSelector]="'cxp-crl-overlay-tab-activity'">
              <div class="overlay-tab-body">
                <cxp-crl-panel-activity
                  [activity]="itemActivity()"
                  [isLoading]="itemActivityLoading()"
                  (previewFile)="onPreviewActivityFile($event)"
                  (downloadFile)="onDownloadActivityFile($event)"
                />
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>

        <cxp-crl-overlay-details-rail
          class="overlay-rail"
          [dueDate]="item.dueDate ?? null"
          [team]="requestDisplay()?.team ?? []"
          [clientContacts]="itemDisplay()?.clientContacts ?? []"
          [currentContactIds]="currentContactIds()"
          [isRestricted]="display.isRestricted"
          [canInvite]="canChangeAccess()"
          [canRemoveAccess]="canChangeAccess()"
          [isViewerOwner]="isViewerOwner()"
          [activity]="itemActivity()"
          [activityLoading]="itemActivityLoading()"
          (invite)="onInvite()"
          (removeContact)="onRemoveContact($event)"
          (viewAllActivity)="onViewAllActivity()"
          (previewActivityFile)="onPreviewActivityFile($event)"
          (downloadActivityFile)="onDownloadActivityFile($event)"
        />
      </div>
    } @else if (display.isResolved) {
      <p class="overlay-empty" [dataSelector]="'cxp-crl-overlay-empty'">This request item is no longer available.</p>
    } @else {
      <p class="overlay-loading" [dataSelector]="'cxp-crl-overlay-loading'">Loading request item…</p>
    }
  </section>
}
